import LoginPage from './pages/Login.page';
import ForgotPasswordPage from './pages/FogotPassword.page';
import ResetPasswordPage from './pages/ResetPassword.page';

export const LOGIN_PAGE_PATH = '/login';
export const RESET_PASSWORD_PATH = '/reset-password';

LoginPage.path = LOGIN_PAGE_PATH;
ForgotPasswordPage.path = '/forgot-password';
ResetPasswordPage.path = RESET_PASSWORD_PATH;
ResetPasswordPage.protectedPath = '/reset-required';

export default {
  pages: {
    LoginPage,
    ForgotPasswordPage,
    ResetPasswordPage,
  },
};
